import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, effect, inject } from '@angular/core';

import { CasinoLobbyService, ConfigProviderService, OptimizedTeaserManager, TeasersStore } from '@casinocore/platform/core';

import { TeasersWrapperComponent } from '../casino-teasers-wrapper/teasers-wrapper.component';

@Component({
    selector: 'cc-teaser-on-lobby-type',
    templateUrl: 'teaser-on-lobby-type.component.html',
    imports: [NgIf, TeasersWrapperComponent],
})
export class TeaserOnLobbyTypeComponent implements OnChanges {
    @Input() lobbyType: string;
    @Input() categoryRoute: string;
    @Input() lobbyProduct: string;
    TopTeaser: string;
    teaserCategoryVal: string;
    isDefaultCategory: boolean = true;
    headerTeasers: any[] = [];
    optimizedHeaderTeasers: any[] = [];
    teasersReady: boolean;
    teasersStore = inject(TeasersStore);

    readonly isTeaserDataInitialised = this.teasersStore.initialised;

    constructor(
        private casinoLobbyService: CasinoLobbyService,
        private configProviderService: ConfigProviderService,
        private optimizedTeaserManager: OptimizedTeaserManager,
    ) {
        effect(() => {
            const siteCoreTeasersByLobbyType = this.teasersStore.siteCoreTeasersByLobbyTypes();
            let siteCoreTeasersInitialised = false;
            if (
                siteCoreTeasersByLobbyType &&
                siteCoreTeasersByLobbyType[this.lobbyType] &&
                siteCoreTeasersByLobbyType[this.lobbyType][this.categoryRoute]
            ) {
                siteCoreTeasersInitialised = siteCoreTeasersByLobbyType[this.lobbyType][this.categoryRoute].initialised;
            }
            if (this.isTeaserDataInitialised() && siteCoreTeasersInitialised) {
                this.bindTeasers();
                this.TopTeaser = this.isDefaultCategory ? 'Top' : 'SubNavigation';
            }
        });
    }

    ngOnChanges() {
        this.bindTeasers();
    }

    bindTeasers() {
        const catInfo = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryRoute);
        if (catInfo && catInfo.categoryInfo) {
            const currentCategory = catInfo.categoryInfo;
            this.teaserCategoryVal = currentCategory.categoryid;
            this.teasersReady = false;
            const optTeaserConfig = this.configProviderService.provideOptimizedTeaserConfig();
            this.isDefaultCategory = this.casinoLobbyService.isDefaultCategory(this.lobbyType, this.categoryRoute);
            if (optTeaserConfig.teaserOptimization) {
                this.bindOptimizedTeaserForCategory();
            } else {
                this.bindNormalTeasersForCategory();
            }
        }
    }

    private bindOptimizedTeaserForCategory() {
        const isDefault: boolean = this.casinoLobbyService.isDefaultCategory(this.lobbyType, this.categoryRoute);
        const displayMode: string = isDefault ? 'Top' : 'SubNavigation';
        const siteCoreTeasersByLobbyTypes = this.teasersStore.siteCoreTeasersByLobbyTypes();
        const siteCoreCategoryData = siteCoreTeasersByLobbyTypes?.[this.lobbyType]?.[this.categoryRoute] ?? null;
        const sitecoreCatTeaserData = siteCoreCategoryData?.teaserData;
        const optTeaserResponse: any = this.optimizedTeaserManager.setOptimizedTeasers(sitecoreCatTeaserData, displayMode);
        if (optTeaserResponse) {
            this.optimizedHeaderTeasers = optTeaserResponse;
        }
        this.teasersReady = true;
    }

    bindNormalTeasersForCategory() {
        this.headerTeasers = [];
        this.isDefaultCategory = this.casinoLobbyService.isDefaultCategory(this.lobbyType, this.categoryRoute);
        this.TopTeaser = this.isDefaultCategory ? 'Top' : 'SubNavigation';
        const normalHeaderTeasers = this.teasersStore.normalTeasers();
        const headerTeasers = normalHeaderTeasers.teasers ?? [];
        const sitecoreTeasers = this.teasersStore.siteCoreTeasersByLobbyTypes();
        const siteCoreTeasersByLobbyTypeandCat = sitecoreTeasers?.[this.lobbyType]?.[this.categoryRoute];
        if (
            siteCoreTeasersByLobbyTypeandCat &&
            siteCoreTeasersByLobbyTypeandCat.teaserData.showTeasers &&
            siteCoreTeasersByLobbyTypeandCat.teaserData.normalTeasers &&
            siteCoreTeasersByLobbyTypeandCat.teaserData.normalTeasers.length > 0 &&
            headerTeasers &&
            headerTeasers.length > 0
        ) {
            headerTeasers.forEach((headerTeaser: any) => {
                const index = siteCoreTeasersByLobbyTypeandCat.teaserData.normalTeasers?.indexOf(
                    siteCoreTeasersByLobbyTypeandCat.teaserData.normalTeasers.filter(
                        (categoryTeaser: any) => categoryTeaser.itemName === headerTeaser.teaserId,
                    )[0],
                );
                if (index !== -1 && !headerTeaser.isEmbeddedTeaser) {
                    this.headerTeasers.push(headerTeaser);
                }
            });
        }
        this.teasersReady = true;
    }
}
